import * as XLSX from 'xlsx';

export type ExcelCatalogFormat = 'shamir-st' | 'shamir-rx';

const getHeaderRow = (rows: unknown[][]) =>
    rows.find((row) => {
        const firstCell = String(row[0] ?? '').trim();
        const secondCell = String(row[1] ?? '').trim();

        return firstCell === 'Part Number' || secondCell === 'Nazwa';
    });

export const detectExcelFormat = (file: ArrayBuffer): ExcelCatalogFormat => {
    const workbook = XLSX.read(file, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const rows = XLSX.utils.sheet_to_json<unknown[]>(worksheet, { header: 1, defval: '' });
    const headerRow = getHeaderRow(rows);

    if (!headerRow) {
        throw new Error('Nie rozpoznano formatu pliku Excel.');
    }

    if (String(headerRow[0]).trim() === 'Part Number') {
        return 'shamir-rx';
    }

    return 'shamir-st';
};
